import util from '../util';

export const LOGINS = 'LOGINS';
export const LOGIN = 'LOGIN';
export const CREATE_LOGIN = 'CREATE_LOGIN';
export const UPDATE_LOGIN = 'UPDATE_LOGIN';
export const VERIFY_LOGIN = 'VERIFY_LOGIN';
export const RESET_LOGIN = 'RESET_LOGIN';
export const RESET_LOGIN_VERIFICATION = 'RESET_LOGIN_VERIFICATION';
export const DELETE_LOGIN = 'DELETE_LOGIN';
export const SET_MFA_LOGIN_TOKEN = 'SET_MFA_LOGIN_TOKEN';
export const DELETE_MFA_LOGIN_TOKEN = 'DELETE_MFA_LOGIN_TOKEN';
export const SET_LOGIN_CRED = 'SET_LOGIN_CRED';
export const DELETE_LOGIN_CRED = 'DELETE_LOGIN_CRED';
export const SET_LEGACY_LOGIN_DISABLED = 'SET_LEGACY_LOGIN_DISABLED';

export const LOGIN_REQUEST = util.requestType(LOGIN);
export const LOGIN_SUCCESS = util.successType(LOGIN);
export const LOGIN_FAILURE = util.failureType(LOGIN);

export const LOGINS_REQUEST = util.requestType(LOGINS);
export const LOGINS_SUCCESS = util.successType(LOGINS);
export const LOGINS_FAILURE = util.failureType(LOGINS);

export const CREATE_LOGIN_REQUEST = util.requestType(CREATE_LOGIN);
export const CREATE_LOGIN_SUCCESS = util.successType(CREATE_LOGIN);
export const CREATE_LOGIN_FAILURE = util.failureType(CREATE_LOGIN);

export const UPDATE_LOGIN_REQUEST = util.requestType(UPDATE_LOGIN);
export const UPDATE_LOGIN_SUCCESS = util.successType(UPDATE_LOGIN);
export const UPDATE_LOGIN_FAILURE = util.failureType(UPDATE_LOGIN);

export const VERIFY_LOGIN_REQUEST = util.requestType(VERIFY_LOGIN);
export const VERIFY_LOGIN_SUCCESS = util.successType(VERIFY_LOGIN);
export const VERIFY_LOGIN_FAILURE = util.failureType(VERIFY_LOGIN);

export const DELETE_LOGIN_REQUEST = util.requestType(DELETE_LOGIN);
export const DELETE_LOGIN_SUCCESS = util.successType(DELETE_LOGIN);
export const DELETE_LOGIN_FAILURE = util.failureType(DELETE_LOGIN);
